import DefaultWidgetContainer from "../../Componant/Widget/DefaultWidgets";

const DefaultWidget = () => {
  return (
    <div className="page-body">
      <DefaultWidgetContainer />
    </div>
  );
};

export default DefaultWidget;
